export const navigation = [
  { label: 'TOP', to: '/' },
  { label: 'ABOUT', to: '/#about' },
  { label: 'BUSINESS', to: '/#business' },
  { label: 'PRODUCTS', to: '/#products' },
  { label: 'COMPANY', to: '/company' },
];

export const heroContent = {
  eyebrow: 'LIQUOR WHOLESALE / EC / DISTRIBUTION',
  title: ['酒類の可能性を、', '広げる。'],
  description: [
    '商品力と供給力を、一つの流れへ。',
    'RYUは、酒類卸売・EC・物流を動かす流通企業です。',
  ],
  proof: [
    { value: '1947', label: 'ESTABLISHED' },
    { value: '卸売', label: 'B2B SUPPLY' },
    { value: '全国', label: 'EC & DISTRIBUTION' },
  ],
};

export const company = {
  name: 'RYU株式会社',
  established: '1947年10月',
  address: '埼玉県児玉郡神川町原新田28-1',
  postalCode: '367-0242',
  phone: '0495-71-5696',
  email: 'info@ryu.plus',
  representative: '櫻庭 周平',
  access: [
    'JR高崎線「本庄駅」より車で15分',
    '関越自動車道「本庄児玉IC」より車で約10分',
  ],
  businesses: [
    '酒類卸販売、小売販売（国内外正規ルート）',
    '業務用配達・法人向け仕入支援',
    '飲食店・小売業向け業務提案',
    '酒類通信販売および在庫供給体制の構築',
  ],
  banks: [
    '三井住友銀行',
    '楽天銀行',
    '住信ＳＢＩネット銀行',
    'ＰＡＹＰＡＹ銀行',
    '埼玉信用組合',
    '足利銀行',
  ],
  marketplace: [
    {
      label: 'AMAZON',
      href: 'https://www.amazon.co.jp/b?node=26286483051&ie=UTF8&marketplaceID=A1VC38T7YXB528&me=A1DY8Y5UB9NDWN',
    },
    { label: 'RAKUTEN', href: 'https://www.rakuten.co.jp/komoriliquor/' },
  ],
};

export const businessItems = [
  {
    number: '01',
    english: 'WHOLESALE',
    japanese: '酒類卸売',
    lead: '多彩な商品を、必要な量で。',
    description:
      '幅広いカテゴリーを取り揃え、飲食店・小売事業者・法人のお客様へ安定して供給。ケース単位の仕入れから継続取引まで、数量・価格・納期に応じた実務的な提案を行います。',
  },
  {
    number: '02',
    english: 'EC BUSINESS',
    japanese: 'EC事業',
    lead: '市場と商品を、ダイレクトにつなぐ。',
    description:
      'Amazon・楽天をはじめとするECチャネルを通じ、全国のお客様へ商品をお届けします。販売動向を捉えた機動的な運営で、商品の価値を次の需要へつなぎます。',
  },
  {
    number: '03',
    english: 'DISTRIBUTION',
    japanese: '流通・物流',
    lead: '速く、正確に、全国へ。',
    description:
      '法人配送から小売販売、通販出荷まで柔軟に対応。調達・在庫・出荷を一体で捉え、スピードと正確性を両立した供給体制を構築しています。',
  },
];

export const strengths = [
  {
    number: '01',
    english: 'PRODUCT',
    title: '幅広い商品ラインナップ',
    description: '定番商品から多様なカテゴリーまで、需要に合わせた品揃えと在庫力で対応します。',
  },
  {
    number: '02',
    english: 'SPEED',
    title: '迅速な仕入れ・流通',
    description: '市場の変化を素早く捉え、仕入れから出荷までをスピーディーに動かします。',
  },
  {
    number: '03',
    english: 'NETWORK',
    title: '全国へ広がる販売網',
    description: 'B2BとECの両輪で、地域や業態を越えて価値ある商品を届けます。',
  },
  {
    number: '04',
    english: 'EXPERIENCE',
    title: '市場を理解した商品提案',
    description: '長年の知見と販売データを活かし、取引先の次の成長につながる提案を行います。',
  },
];

// Company facts and service coverage. Values are isolated here for easy maintenance.
export const companyStats = [
  { value: 1947, prefix: '', suffix: '', label: 'ESTABLISHED', note: '設立年' },
  { value: 47, prefix: '', suffix: '', label: 'PREFECTURES', note: '全国配送対応' },
  { value: 2, prefix: '', suffix: '', label: 'EC CHANNELS', note: '主要ECモール' },
];

export const productCategories = [
  { english: 'WHISKY', japanese: 'ウイスキー' },
  { english: 'WINE', japanese: 'ワイン' },
  { english: 'SAKE', japanese: '日本酒' },
  { english: 'SPIRITS', japanese: 'スピリッツ' },
  { english: 'BEER', japanese: 'ビール' },
  { english: 'OTHER', japanese: 'その他酒類' },
];

export const greeting = [
  'RYU株式会社は、酒類業界で「正規品のみを扱う」という一貫した方針のもと、流通の信頼性を支える仕組みと、現場の視点に立った運営に取り組んでまいりました。',
  '私は、公認会計士として40年ほど経営問題に関わり、上場プロジェクト責任者、上場企業の役員、そして大学院（MBA）教授として、マネジメントの研究と教育に携わってまいりました。',
  'そうした経験から、「どんなに商品やサービスが優れていても、信頼関係の構築には特別な努力が必要だ」ということを強く実感しております。',
  '品質の正しさ、納品の正確さ、価格の納得感。これらは全て“当然”であるからこそ、私たちは一つひとつを、愚直に、誠実に積み重ねてまいります。',
  '今後は、海外取引にも積極的に取り組み、日本の素晴らしい酒文化を丁寧に、確実に世界へ伝えてまいります。',
  '末永くご信頼いただける企業となるべく、社員一同、より一層真摯に努めてまいりますので、変わらぬご支援を賜りますよう、心よりお願い申し上げます。',
];

export const faqs = [
  {
    question: '酒販免許を持っていなくても購入できますか？',
    answer:
      '弊社では卸販売免許と共に小売販売免許も所持してますので、個人のお客様でもご購入いただけます。ただし一部業務用商品のご注文には法人確認が必要な場合がございます。',
  },
  {
    question: '法人・飲食店向けの取引は可能ですか？',
    answer:
      'はい、多くの飲食店・小売業者様との取引実績がございます。ご希望の商品・数量をお知らせいただければ、個別に対応いたします。',
  },
  {
    question: '最低注文数量や金額の条件はありますか？',
    answer:
      '通常のご注文には特に制限はございませんが、卸価格のご提供には一定の数量・取引継続条件がございます。詳細はお問い合わせください。',
  },
  {
    question: '納品書・請求書・領収書の発行は可能ですか？',
    answer:
      'はい、すべて対応しております。ご注文時にご希望の書類をお知らせいただければ、同封またはPDFでご送付いたします。',
  },
  {
    question: '支払い方法には何がありますか？',
    answer:
      '銀行振込（先払い・掛け払い）、代引き、PayPay銀行など複数の方法に対応しています。法人様向けには請求書払いもご相談可能です。',
  },
  {
    question: '商品は全国配送対応ですか？',
    answer:
      'はい、日本全国に発送可能です。地域によっては翌日配達も対応しております。離島への配送については別途ご相談ください。',
  },
  {
    question: '海外発送はできますか？',
    answer:
      '海外発送は法人契約を締結したパートナー企業様に限り対応しております。一般のお客様への越境発送は行っておりません。',
  },
  {
    question: '商品に破損があった場合の対応は？',
    answer:
      '商品到着後すぐにご確認ください。万一破損・不備があった場合は、速やかにご連絡いただければ、交換または返金にて対応させていただきます。',
  },
  {
    question: '通販サイト以外でも購入できますか？',
    answer:
      'はい、Amazon・楽天以外に、FAX・メールによる直接注文にも対応しております。定期仕入や業務用ご希望の方はぜひお問い合わせください。',
  },
];
